const DEFAULT_MESSAGE = "Something went wrong. Please try again.";
const MAX_MESSAGE_LENGTH = 240;

export function getUserFacingError(error, fallback = DEFAULT_MESSAGE) {
  const code = String(error?.code ?? "").toUpperCase();
  const status = Number(error?.status);
  const raw = firstUsefulMessage(error);

  if (code === "4001" || code === "ACTION_REJECTED" || /user rejected|user denied/i.test(raw)) {
    return "Request cancelled. No changes were made.";
  }
  if (code === "-32002" || /request (is )?already pending|already open/i.test(raw)) {
    return "A wallet request is already open. Reopen your wallet to finish it.";
  }
  if (code === "INSUFFICIENT_FUNDS" || /insufficient funds/i.test(raw)) {
    return "This wallet does not have enough funds for the transaction and network fee.";
  }
  if (code === "CALL_EXCEPTION" || /estimateGas|execution reverted|unknown custom error/i.test(raw)) {
    return "The contract rejected this action. Check the selected Robinhood Chain network and whether the action was already completed.";
  }
  if (code === "NETWORK_ERROR" || /failed to fetch|network request failed|coordinator request failed/i.test(raw)) {
    return "The network request failed. Check your connection and try again.";
  }
  if (code === "TIMEOUT" || /timed? out/i.test(raw)) {
    return "The request timed out. Its final status may still be pending; refresh before trying again.";
  }
  if (status === 401) return "Your wallet session expired. Reconnect and sign in again.";
  if (status === 403) return "This wallet is not allowed to perform that action.";
  if (status === 429) return "Too many requests were sent. Wait a moment and try again.";

  const cleaned = cleanMessage(raw) || cleanMessage(fallback) || DEFAULT_MESSAGE;
  return truncateMessage(cleaned);
}

function firstUsefulMessage(error) {
  const candidates = [
    error?.reason,
    error?.shortMessage,
    error?.info?.error?.message,
    error?.error?.message,
    error?.message,
    typeof error === "string" ? error : ""
  ];
  return String(candidates.find((value) => value && !/^unknown custom error$/i.test(String(value).trim())) || "");
}

function cleanMessage(value) {
  return String(value || "")
    .replace(/\s*\((?:action|operation)=[\s\S]*$/i, "")
    .replace(/\s+(?:transaction|invocation|revert|receipt)=\{?[\s\S]*$/i, "")
    .replace(/\s+version=[^\s,)]+[),]?\s*$/i, "")
    .replace(/0x[0-9a-f]{96,}/gi, "transaction data")
    .replace(/\s+/g, " ")
    .trim();
}

function truncateMessage(message) {
  if (message.length <= MAX_MESSAGE_LENGTH) return message;
  const clipped = message.slice(0, MAX_MESSAGE_LENGTH - 1).replace(/[\s,;:.\-]+$/g, "");
  return `${clipped}…`;
}
